import { Result } from "antd";
import styled from "styled-components";

export const StyledResult = styled(Result)`
  margin: auto;
  padding-top: 100px;
`;
